import { render, staticRenderFns } from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue?vue&type=template&id=d7651d2e&scoped=true"
import script from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue?vue&type=script&lang=js"
export * from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue?vue&type=script&lang=js"
import style0 from "./WabaSupsisPartnerClientCertificationStatusUpdate.vue?vue&type=style&index=0&id=d7651d2e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7651d2e",
  null
  
)

export default component.exports